import {
    COUNTRY_SUCCESS,
    COUNTRY_FAIL,
    COUNTRY_PENDING
} from "../../actions/types";

const initialState = { 
    countries: [],
    isCountriesLoading: false,
    };

const countries_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case COUNTRY_SUCCESS:
            return {
                ...state,
                countries: payload.countries,
                isCountriesLoading: false,
            };
        case COUNTRY_PENDING:
            return {
                ...state,
                countries: payload.countries,
                isCountriesLoading: true,
            };
        case COUNTRY_FAIL:
            return {
                ...state,
                countries: [],
                isCountriesLoading: false,
            };
        default:
            return state;
    }
}
export default countries_reducer